
export default class Util {

	/**
	 *
	 * @param {HTMLElement} sliderElement
	 * @param {HTMLElement} controlsElement
	 */
	static sliderControls(sliderElement, controlsElement) {
		const slider = new Splide(sliderElement, {
			arrows: false,
			type: 'loop',
			pagination: false,
		});
		slider.mount();

		const pagination = [];
		const arrows = [];
		controlsElement.querySelectorAll('[data-slider-control]').forEach(c => {
			(isNaN(parseInt(c.dataset.sliderControl)) ? arrows : pagination).push(c);
		});

		pagination.forEach(c => c.addEventListener('click', () => slider.go(parseInt(c.dataset.sliderControl))));
		arrows.forEach(c => c.addEventListener('click', () => slider.go(c.dataset.sliderControl)));

		slider.on('move', (index) => {
			pagination.forEach(c => {
				c.classList.toggle('selected', c.dataset.sliderControl === index.toString());
			});
		});
	}


}
